/**
 * featurebase/constants.ts
 * Static constants for the Featurebase integration module.
 */

import { Brand } from '@enfomentis/shared/config';

/** Featurebase SDK script URL */
export const FEATUREBASE_SDK_URL = 'https://do.featurebase.app/js/sdk.js';

/**
 * localStorage key for user consent state.
 * Resolves to `em-featurebase-consent-v1`.
 */
export const FEATUREBASE_CONSENT_KEY = `${Brand.cachePrefix}-featurebase-consent-v1`;

/** Supabase Edge Function name for HMAC retrieval */
export const FEATUREBASE_EDGE_FUNCTION = 'featurebase-hmac';

/**
 * Featurebase app ID (hex, used by messenger SDK boot).
 * Empty string if env var is not configured — service validates at boot time.
 */
export const FEATUREBASE_APP_ID: string = import.meta.env['VITE_FEATUREBASE_APP_ID'] ?? '';

/**
 * Featurebase workspace subdomain (used by feedback widget).
 * Empty string if env var is not configured — service validates at init time.
 */
export const FEATUREBASE_ORGANIZATION: string = import.meta.env['VITE_FEATUREBASE_ORGANIZATION'] ?? '';

/** Minimum interval (ms) between retry attempts for SDK re-initialization */
export const RETRY_COOLDOWN_MS = 5_000;

/** Maximum time (ms) to wait for the SDK `identify` callback before proceeding */
export const IDENTIFY_TIMEOUT_MS = 5_000;
